export default "__VITE_ASSET__DZGtqmq0__"